import type { VendorConfig } from '../types';
import { SHARED_SEARCH_KEYWORDS, SHARED_SQL_AGGREGATES, SHARED_SQL_KEYWORDS, SHARED_SQL_SCALARS } from './shared';

const ltsConfig: VendorConfig = {
  id: 'lts',
  label: '华为云 LTS',
  searchKeywords: SHARED_SEARCH_KEYWORDS,
  searchBuiltinFields: [
    { name: '_exists_', detail: '存在性判断', doc: 'LTS 搜索语法：_exists_:fieldName 判断字段是否存在' },
    { name: '_missing_', detail: '缺失判断', doc: 'LTS 搜索语法：_missing_:fieldName 判断字段是否缺失' },
    { name: 'hostName', detail: '采集主机', doc: 'LTS 内置字段：采集主机名' },
    { name: 'hostIP', detail: '采集主机 IP', doc: 'LTS 内置字段：采集主机 IP' },
    { name: 'logGroup', detail: '日志组', doc: 'LTS 内置字段：日志组名称' },
    { name: 'logStream', detail: '日志流', doc: 'LTS 内置字段：日志流名称' },
  ],
  fieldAssignOperators: [':', '='],
  sqlKeywords: Array.from(new Set([...SHARED_SQL_KEYWORDS, 'OVER', 'PARTITION', 'EXISTS'])),
  sqlFunctions: [
    ...SHARED_SQL_AGGREGATES,
    ...SHARED_SQL_SCALARS,
    { name: 'date_format', signature: 'date_format(time, format)', doc: 'LTS：时间格式化' },
    { name: 'date_trunc', signature: 'date_trunc(unit, time)', doc: 'LTS：时间截断' },
    { name: 'from_unixtime', signature: 'from_unixtime(unixtime)', doc: 'LTS：unix 时间转日期' },
    { name: 'regexp_extract', signature: 'regexp_extract(str, pattern[, group])', doc: 'LTS：正则提取' },
    { name: 'regexp_like', signature: 'regexp_like(str, pattern)', doc: 'LTS：正则匹配判断' },
    { name: 'split_part', signature: 'split_part(str, delimiter, idx)', doc: 'LTS：字符串切分' },
    { name: 'cardinality', signature: 'cardinality(field)', doc: 'LTS：基数估计' },
  ],
};

export default ltsConfig;
